// extracted by mini-css-extract-plugin
export var smallSpinner = "_qs-0";